module.exports = "/images/vendor/flag-icon-css/flags/4x3/cx.svg?aa81bb9ef6d3ed6a6d20b6468ee40d02";